<script lang="ts">
	import type { CoverImage } from '$lib/features/image/imageDetails.type';
	import { UrlUtil } from '$lib/utils/url.util';

	const { images, isEagerLoad }: { images: CoverImage[]; isEagerLoad: boolean } = $props();
</script>

<div
	class={{
		'grid h-full w-full gap-0.5': true,
		'grid-cols-1': images.length === 1,
		'grid-cols-2': images.length > 1,
		'grid-rows-1': images.length < 3,
		'grid-rows-2': images.length >= 3
	}}
>
	{#each images.slice(0, 4) as image, i (image.filename)}
		<div class={{ 'relative h-full w-full overflow-hidden bg-base-300': true, 'row-span-2': images.length === 3 && i === 0 }}>
			<img
				class="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
				src={UrlUtil.getFullImageUrl(image)}
				alt={image.altText}
				width={image.width}
				height={image.height}
				loading={isEagerLoad ? 'eager' : 'lazy'}
				decoding="async"
			/>
		</div>
	{/each}
	{@render DarkOverlay()}
</div>

{#snippet DarkOverlay()}
	<div
		class="pointer-events-none absolute inset-0 bg-linear-to-t from-black to-transparent opacity-60 transition-opacity group-hover:opacity-30 md:bg-linear-to-r md:opacity-40"
	></div>
{/snippet}
